import React from "react"
import { useState } from "react"
import clsx from "clsx"

export interface Expandable {
  className?: string
  label: string
  value: string
}

export const LuiExpandableBanner: React.FC<Expandable> = (props) => {
  const [display, setDisplay] = useState(false)
  const displayAnswer = () => {
    display ? setDisplay(false) : setDisplay(true)
  }
  return (
    <div className={"lui-divider"}>
      <div data-testid={"click-to-expand"} className={"lui-expand-header"} onClick={displayAnswer}>
        <p>
          {props.label}
          <i
            className={clsx(
              display
                ? "lui-expand-icon material-icons-round lui-expand-icon-transform"
                : "lui-expand-icon material-icons-round"
            )}
          >
            {"expand_more"}
          </i>
        </p>
      </div>
      <div
        data-testid={"expand-text"}
        className={clsx("lui-collapse-text", "change-me", display ? "lui-expanded-text" : "lui-collapse-text")}
      >
        <p>{props.value}</p>
      </div>
    </div>
  )
}
